"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _overlord = require("./overlord");

var _overlord2 = _interopRequireDefault(_overlord);

var _standard = require("./standard");

var _standard2 = _interopRequireDefault(_standard);

var _void = require("./void");

var _void2 = _interopRequireDefault(_void);

var _prerelease = require("./prerelease");

var _prerelease2 = _interopRequireDefault(_prerelease);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [].concat(_overlord2.default, _standard2.default, _void2.default, _prerelease2.default);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvbGVhZ3Vlcy9saXN0L2luZGV4LmpzIl0sIm5hbWVzIjpbImNvbmNhdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztrQkFHZ0IsR0FBR0EsTUFBSCw4RSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgT3ZlcmxvcmQgZnJvbSBcIi4vb3ZlcmxvcmRcIlxuaW1wb3J0IFN0YW5kYXJkIGZyb20gXCIuL3N0YW5kYXJkXCJcbmltcG9ydCBWb2lkIGZyb20gXCIuL3ZvaWRcIlxuaW1wb3J0IFByZXJlbGVhc2UgZnJvbSBcIi4vcHJlcmVsZWFzZVwiXG5pbXBvcnQgdHlwZSB7U3RhdGUgYXMgTGVhZ3VlfSBmcm9tIFwiLi4vcmF3XCJcblxuZXhwb3J0IGRlZmF1bHQgKFtdLmNvbmNhdChPdmVybG9yZCwgU3RhbmRhcmQsIFZvaWQsIFByZXJlbGVhc2UpOiBMZWFndWVbXSlcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/leagues/list/index.js
// module id = 361
// module chunks = 0